import React, { ReactElement } from 'react';
import App from './app/App';
import i18next from './app/utils/i18n';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/300-italic.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/400-italic.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/500-italic.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/600-italic.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/700-italic.css';
import '@fontsource/cambo/400.css';
import '@fontsource/varela-round/400.css';
import rootContainer from './app/utils/rootContainer';
import * as am5 from '@amcharts/amcharts5';
import AppSettingsProvider from './app/features/settings/providers/AppSettingsProvider';
import AppLangProvider from './app/features/lang/providers/AppLangProvider';
import AppThemeProvider from './app/features/theme/providers/AppThemeProvider';
import AppErrorBoundary from './app/features/error/boundary/AppErrorBoundary';
import axios from 'axios';
import { globalConfig, globalConfigUrl } from './app/config/config';
import { MatomoProvider, createInstance } from '@jonkoops/matomo-tracker-react';
import { OidcConfiguration, OidcProvider } from '@axa-fr/react-oidc';

i18next.init();

axios
	.get(globalConfigUrl)
	.then((response) => {
		globalConfig.config = response.data;
		globalConfig.set(response.data);
		am5.addLicense(globalConfig.get().APP_AMCHART_LICENCE);

		const matomoInstance = createInstance({
			urlBase: globalConfig.get().APP_MATOMO_BASE_URL,
			siteId: globalConfig.get().APP_MATOMO_SITE_ID,
			linkTracking: false,
			configurations: {
				disableCookies: true,
				setSecureCookie: true,
			},
		});

		const oidcConfig: OidcConfiguration = {
			authority: globalConfig.get().REACT_APP_AZURE_OIDC_AUTHORITY,
			client_id: globalConfig.get().REACT_APP_AZURE_OIDC_CLIENT_ID,
			redirect_uri: location.origin + globalConfig.get().REACT_APP_AZURE_OIDC_REDIRECT_URI,
			silent_redirect_uri: location.origin + globalConfig.get().REACT_APP_AZURE_OIDC_REDIRECT_URI_SILENT,
			scope: globalConfig.get().REACT_APP_AZURE_OIDC_SCOPE,
			demonstrating_proof_of_possession: false,
		};

		return (
			<>
				<OidcProvider configuration={oidcConfig}>
					<AppErrorBoundary>
						<AppSettingsProvider>
							<AppLangProvider>
								<AppThemeProvider>
									<MatomoProvider value={matomoInstance}>
										<App />
									</MatomoProvider>
								</AppThemeProvider>
							</AppLangProvider>
						</AppSettingsProvider>
					</AppErrorBoundary>
				</OidcProvider>
			</>
		);
	})
	.catch(() => {
		return <p style={{ color: 'red', textAlign: 'center' }}>Error while fetching global config</p>;
	})
	.then((reactElement: ReactElement) => {
		rootContainer?.render(reactElement);
	});
